import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Container } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { Route } from 'react-router-dom';
import feathersConnect from './../../../providers/feathersConnect';
import AList from '../../auto/AList';

const PAGE_RANGE = 10;

const INITIAL_STATE = {
  searchForm: {
    loading: false,
    values: {
      matriculaNacional: '',
      matriculaProvincial: ''
    },
    error: null
  },
  cooperativas: []
};

class InformePersonasView extends Component {

  constructor (props) {
    super(props);

    this.state = INITIAL_STATE;

    this.PersonaService = this.props.feathers.service('/api/personas');
  }

  createInputHandler (name, type = 'input') {
    return (e, input) => {
      let valueSelector = {
        input: () => {
          return e.target.value;
        },
        select: () => {
          return input.value;
        }
      };

      this.changeFormValue(name, valueSelector[type]());
    };
  }

  mapCooperativaToItemList = (cooperativas) => cooperativas.map((cooperativa) => ({
    id: cooperativa.id,
    header: cooperativa.nombre,
    description: `MN: ${cooperativa.matriculaNacional} MP: ${cooperativa.matriculaProvincial}`
  }))

  selectPersona (persona) {
    window.open(`/reporte-personas?id=${persona.id}`);
  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    return (
      <div>
        <AList
          pageRange={PAGE_RANGE}
          mapFunction={(persona) => ({
            id: persona.id,
            header: `${persona.apellido}, ${persona.nombre}`,
            description: `DNI ${persona.dni}`
          })}
          service={this.PersonaService}
          options={{
            disableRemove: true,
            selectItem: this.selectPersona.bind(this)
          }} />
      </div>
    );
  }
}

export default feathersConnect(
  connect(
    InformePersonasView.mapStateToProps,
    InformePersonasView.mapDispatchToProps
  )(InformePersonasView)
);



// WEBPACK FOOTER //
// ./client/components/pages/informes/InformePersonasView.js